<div class="bw-dialog info-dialog">

  <lib-page-header screenName="About" title="About TaskSense" backTo="">
    <mat-icon icon>info</mat-icon>
    <ng-container subtitle>
      <span>Intelligent task management for modern teams</span>
    </ng-container>
  </lib-page-header>

  <div class="bw-body">
    <div class="about-hero">
      <img class="about-logo" src="logo.svg" alt="TaskSense logo" width="96" height="96">
      <div class="about-wordmark">
        <span class="about-name">TaskSense</span>
        <span class="about-tagline">Intelligent task management for modern teams</span>
      </div>
    </div>

    <p class="intro">
      Welcome to TaskSense, your intelligent companion for task management and productivity.
      We help individuals and teams simplify their workflows, prioritize effectively, and achieve their goals effortlessly.
    </p>

    <h3>Our Mission</h3>
    <p>
      At TaskSense, our mission is to empower people to work smarter, not harder. We bridge the gap
      between organization and productivity by providing tools that adapt to your unique needs.
    </p>

    <h3>Why Choose Us?</h3>
    <div class="feature-grid">
      <div class="feature-card">
        <mat-icon>auto_awesome</mat-icon>
        <strong>Smart Features</strong>
        <span>Intuitive AI-driven tools for task prioritization</span>
      </div>
      <div class="feature-card">
        <mat-icon>group</mat-icon>
        <strong>Collaboration</strong>
        <span>Share tasks, set deadlines, stay in sync with your team</span>
      </div>
      <div class="feature-card">
        <mat-icon>tune</mat-icon>
        <strong>Customizable</strong>
        <span>Personalize your experience to match your workflow</span>
      </div>
      <div class="feature-card">
        <mat-icon>security</mat-icon>
        <strong>Secure</strong>
        <span>Your data is safe, private, and protected</span>
      </div>
    </div>

    <h3>Our Story</h3>
    <p>
      TaskSense was born from a passion for productivity and a desire to solve the everyday
      challenges of managing tasks. What started as a small idea grew into a robust platform
      trusted by thousands of users globally.
    </p>

    <h3>Join Us</h3>
    <p>
      Whether you're a freelancer, a busy professional, or part of a growing team, TaskSense is
      here to help you reach new heights. Try TaskSense today and experience productivity like
      never before.
    </p>
  </div>


</div>
